/**
 * TODO: 
 * - [x] Ledger need WitnessScript in PSBT to sign P2WSH correctly and it must be removed in P2WPKH case to finalize it!!!
 * - [x] Large MultiSig Policy P2WSH unable to finalize and extract with bitcoinjs-lib but succesfully with bitcoin core finalizepsbt!!!
 * - [x] Coin Selection (UTXOs sorting) !!!
 * - [x] Batch Multi-Outputs !!!
 * - [x] Inputs / UTXOs type (p2sh + wrapped)
 * - [x] Tx Type mixed !!!
 * - [ ] Combine PSBTs
 * - [X] BASE64 encoding differences -> PSBT -> bip174.org -> Bitcoin Core * 
 * - [x] KeyChain & Bip32DerivationPath Input Matrix!!!
 * - [x] Transaction Fee Input!!!
 * - [ ] Set Input Sequence
 * - [x] Estimate Fees
 * - [x] Get Address info Create TX/PSBT without Ledger App Client (splitTransaction|serializeTransactionOutputs methods)
 * - [x] CoinJoin - PSBT Inputs/Bip32 mapping
 * - [X] BTC/Sats conversion
 * - [x] PubKey compressed Display
 * - [x] Signatures List
 * - [x] Bluetooth Transport Client
 * - [x] Bluetooth + testnet checkbox instantiate new HWI client with default testnet boolean
 * - [X] UTXOs and globalInfo reset (ex. !coinjoin)
 * - [X] Bitcoin Core state
 * - [ ] ETH App?
 */

//import { listen } from "@ledgerhq/logs";

import * as bitcoin from "bitcoinjs-lib"

// Web-HID Transport
import TransportWebHID from "@ledgerhq/hw-transport-webhid";
import TransportWebBLE from "@ledgerhq/hw-transport-web-ble";

import HWI from './hwi.js'

let hwi = new HWI(TransportWebHID) // new HWI(TransportWebBLE)
hwi.testnet = false

import Wallet from "@ramsi88/btc-signer";
import {TX, PSBT} from '@ramsi88/btc-tx-builder'

import axios from 'axios';

const satoshi = 10 ** 8

let debug

const StandardPurpose = {
  p2tr : "86'",
  p2wpkh : "84'",
  p2wpkhInP2sh : "49'",
  p2pkh : "44'",
}

const MAINNET = {
  /**
   * The message prefix used for signing Bitcoin messages.
   */
  messagePrefix: '\x18Bitcoin Signed Message:\n',
  /**
   * The Bech32 prefix used for Bitcoin addresses.
   */
  bech32: 'bc',
  /**
   * The BIP32 key prefixes for Bitcoin.
   */
  bip32: {
    /**
     * The public key prefix for BIP32 extended public keys.
     */
    public: 0x0488b21e,
    /**
     * The private key prefix for BIP32 extended private keys.
     */
    private: 0x0488ade4,
  },
  /**
   * The prefix for Bitcoin public key hashes.
   */
  pubKeyHash: 0x00,
  /**
   * The prefix for Bitcoin script hashes.
   */
  scriptHash: 0x05,
  /**
   * The prefix for Bitcoin Wallet Import Format (WIF) private keys.
   */
  wif: 0x80,
}

const TESTNET = {
  messagePrefix: '\x18Bitcoin Signed Message:\n',
  bech32: 'tb',
  bip32: {
    public: 0x043587cf,
    private: 0x04358394,
  },
  pubKeyHash: 0x6f,
  scriptHash: 0xc4,
  wif: 0xef,
}

//Display the header in the div which has the ID "main"
const initial = "<h3>Connect a Ledger hardware wallet and open Bitcoin or Bitcoin Testnet app.</h3>";
const $main = document.getElementById("debug");
const addr = document.getElementById("addr");
const create = document.getElementById("create");
const decode = document.getElementById("decode");
const psbtInfo = document.getElementById("psbt-info");
const signPsbt = document.getElementById("sign-psbt");
const sign = document.getElementById("sign");
const signMessage = document.getElementById("sign-message");
const fgpr = document.getElementById("fgpr")
const xpub = document.getElementById("xpub")
const register = document.getElementById("register")
const theme = document.getElementById("theme")

let selectedTheme = "light"
$main.innerHTML = initial;

let prevTx = {}
let psbtFormatted = {}
let globalPSBT;
let hexed = undefined;
let globalInfo;
let coinjoin = []
let signMode = false
let balance = 0
let targetFee = 100
let satsIncrease = 10
let selectedAmount = 0

let price = 0
let block = 0

/**
 * MENU
 */
document.getElementById('btn-manager').addEventListener("click", () => {
  document.getElementById('ledger-manager').classList.toggle("hidden");
  document.getElementById('btn-manager').classList.toggle("btn-active");
})

document.getElementById('btn-register').addEventListener("click", () => {
  document.getElementById('register-policy').classList.toggle("hidden");
  document.getElementById('btn-register').classList.toggle("btn-active");
})

document.getElementById('btn-create').addEventListener("click", () => {
  document.getElementById('create-div').classList.toggle("hidden");
  document.getElementById('btn-create').classList.toggle("btn-active");
})

document.getElementById('btn-decode').addEventListener("click", () => {
  document.getElementById('decode-psbt').classList.toggle("hidden");
  document.getElementById('btn-decode').classList.toggle("btn-active");
})

document.getElementById('btn-finalize').addEventListener("click", () => {
  document.getElementById('finalize-broadcast').classList.toggle("hidden");
  document.getElementById('btn-finalize').classList.toggle("btn-active");
})

document.getElementById('btn-message').addEventListener("click", () => {
  document.getElementById('message-sign').classList.toggle("hidden");
  document.getElementById('btn-message').classList.toggle("btn-active");
})

/**
 * STATE LISTENERS
 */
document.getElementById("ble").addEventListener('click', ()=> bleClient())

document.getElementById("network").addEventListener('change', () => {
  hwi.testnet = !hwi.testnet
  console.log("[TESTNET]: ",hwi.testnet)
});

document.getElementById("debug-mode").addEventListener('change', () => {
  debug = document.getElementById('debug-mode').checked
  console.log("[DEBUG]: ", debug)
});

document.getElementById("sign-mode").addEventListener('change', () => {
  signMode = !signMode
  console.log("[sign-mode]: ", signMode)
});

document.getElementById("core").addEventListener('change', () => {
  console.log("[CORE]: ", document.getElementById("core").checked)
});

document.getElementById("test-broadcast").addEventListener('change', () => {
  console.log("[TEST-BROADCAST]: ", document.getElementById("test-broadcast").checked)
});

window.addEventListener('load', async ()=>{
  theme.click()
  const wallet = new Wallet()
  //block
  block = await wallet.getApi("block", `https://mempool.space/api/blocks/tip/height`)
  //price
  price = (await wallet.getApi("price", `https://mempool.space/api/v1/prices`)).USD
  //console.log(`PRICE: ${price} $ | BLOCK: ${block}`)
  document.getElementById('btc-info').innerHTML = (`PRICE: ${price} $ | BLOCK: ${block}`)
  setInterval(async()=> await btcInfo(),60*1000)
  //hwi.createPsbt()
  //hwi.editPsbt("3LQYLTyh9amMshr8JJXbuDTJjyuKBB26d1",1000)
  //console.log(hwi.toBase64())
})

theme.addEventListener("click",() => {
  if (selectedTheme === "light") {
    selectedTheme = "dark"
    document.getElementById("theme").innerHTML = `theme [${selectedTheme}]`
    document.getElementById("main").style.background = "black"
    document.getElementById("main").style.color = "white"
    document.querySelectorAll('div').forEach(div => {
      div.style.boxShadow = '0px 0px 5px 1px inset rgba(255, 255, 255, 0.5)';
    })
  } else {
    selectedTheme = "light"
    document.getElementById("theme").innerHTML = `theme [${selectedTheme}]`
    document.getElementById("main").style.background = "white"
    document.getElementById("main").style.color = "black"
    document.querySelectorAll('div').forEach(div => {
      div.style.boxShadow = '5px 5px 10px 1px black';
    })
  }
})

/**
 * Wallet Client
 */

addr.addEventListener("click", async () => {
  const get_info = document.getElementById('get-info').checked
  try {
    !get_info && await hwi.getClient()
    const path = document.getElementById('path').value
    
    const bitcoinAddress = get_info ? path : await hwi.getAddress(path)
    
    //const addrTo = document.getElementById('addr-to').value
    //const amount = document.getElementById('amount').value
    //const txType = document.getElementById('tx-type').value

    displayData(bitcoinAddress)

    createQR(bitcoinAddress)

    const pubkey = get_info ? "" : compressPublicKey(await hwi.getPub(path))
    //console.log("[PUB]:", pubkey)
    push(`[Address]: ${bitcoinAddress}`)
    document.getElementById('pub-view').innerHTML = `[PubKey]: ${pubkey}`
    
    try {
      await getAddressInfo(bitcoinAddress).then(async (infos) => {
        debug && console.log("[infos]: ",infos)
      })
    } catch (error) {
      console.log("[ADDR INFOS] error",error)
      !get_info && await hwi.closeClient()
    }
    
    !get_info && await hwi.closeClient()
  } catch (e) {
    console.log(e.message || e);
    push(e.message)
    //!get_info && 
    !get_info && await hwi.closeClient()
  }
})

create.addEventListener("click", async() => {
  try {
    //await hwi.getClient()
    const path = document.getElementById('path').value
    //const bitcoinAddress = await hwi.getAddress(path)
    //const pubkey = compressPublicKey(await hwi.getPub(path))
    //console.log("[PUB]:", pubkey)

    const scriptFrom = document.getElementById('script-from').value
    const addrFrom = document.getElementById('addr-from').value
    const addrTo = document.getElementById('addr-to').value
    const amount = document.getElementById('amount').value
    const txType = document.getElementById('tx-type').value
    const getxpubs = [...fetchXpubs(document.getElementById('global-map-xpub').value)]
    //console.log("[KEYCHAIN]: ",getxpubs)
    const getbip32 = document.getElementById('coinjoin').checked ? document.getElementById('input-map-bip32').value : [...fetchPubs(document.getElementById('input-map-bip32').value)]
    //console.log("[BIP32]: ",getbip32)

    //addAmount()

    let start = 0
    let target = document.getElementById('est-fees').value
    targetFee = document.getElementById('fees').value
    selectedAmount = 0

    while (start <= target) {
      addAmount()
      const max = document.getElementById('max').checked
      if (max) {
        document.getElementById('amount').value = 0
        document.getElementById('amount').value = (selectedAmount - targetFee) // satoshi
      }
      try {
        await createUnsignedTx(addrTo, scriptFrom, globalInfo.ids, max?(selectedAmount - targetFee).toString() : amount, globalInfo.balance, txType).then(async (unsigned) => {
          try {            
            if (target / start > 1) {satsIncrease+=1}

            await createPsbt(scriptFrom, globalInfo.ids, globalInfo.prevTxs, unsigned, getxpubs, getbip32,txType).then(async(res) => {
              //console.log("TX/PSBT CREATED ✅")
              push(`✅ ₿ TX/PSBT created: Selected Amount ${(selectedAmount / satoshi).toFixed(8)} Fees ${(targetFee / satoshi).toFixed(8)}`)
              //console.log("[START]:", start)
              //console.log("[TARGET]:", target)
              //console.log("[TARGET_FEE]:",targetFee)
              
              start = res;
              //if (target / start > 1) {satsIncrease+=1}
              //targetFee++
              targetFee = parseInt(targetFee) + satsIncrease
              //await hwi.closeClient()
            })
            //await hwi.closeClient()
          } catch (error) {
            console.log("[createPsbt] error", error)
            push(`❌ [ERROR] creating PSBT`)
            throw "❌ [createPsbt] error"            
            //await hwi.closeClient()
          }          
        })
      } catch (error) {
        console.log("[createUnsignedTx] error",error)
        push(`❌ [ERROR] creating TX/PSBT`)
        break
        //await hwi.closeClient()
      }
    }
    if (document.getElementById('coinjoin').checked) {document.getElementById('coinjoin').checked = false}
  } catch (error) {
    console.log("[ADDR INFOS] error",error)
    push(error)
    //await hwi.closeClient()
  }
})

fgpr.addEventListener("click", async() => {
  try {
    await hwi.getClient()
    
    const fingerprint = await hwi.getFingerprint()
    //console.log("[FGPR]:", fingerprint)
    document.getElementById("fgpr-view").innerHTML = `[FGPR]: ${fingerprint}`
    await hwi.closeClient()
    
  } catch (error) {
    console.log(error)
    push(error)
    await hwi.closeClient()
  }
})

xpub.addEventListener("click", async() => {
  //const hwi = new HWI()
  try {
    await hwi.getClient()
    const path = document.getElementById('path').value
    const xpubkey = await hwi.getXpub(path,70617039) ////76067358 - 70617039
   
    document.getElementById("xpub-view").innerHTML = `[XPUB]: ${xpubkey}`
    //await hwi.closeClient()

    //console.log("[DECODED]: ", Buffer.from(base58.decode(xpubkey)).toString('hex'))
    const extPub = await hwi.getPub(path)
    //await hwi.getClient()
    const pubkey = compressPublicKey(extPub)
    document.getElementById('pub-view').innerHTML = `[PubKey]: ${pubkey}`
    //console.log("[PUB]:", pubkey)

    await hwi.closeClient()
  } catch (error) {
    console.log(error)
    push(error)
    await hwi.closeClient()
  }
})

register.addEventListener("click", async() => {
  //const hwi = new HWI()
  try {
    await hwi.getClient()
    const b64 = document.getElementById('base64').value
    //hwi.importFromB64(b64)
    const path = document.getElementById('path').value
    const miniscript = document.getElementById('policy').value
    const keychains = document.getElementById("keychains").value

    const addrTo = document.getElementById('addr-to').value
    const amount = document.getElementById('amount').value
    const txType = document.getElementById('tx-type').value

    //console.log(miniscript)
    hwi.setDescriptorTemplate(miniscript)

    const walletName = document.getElementById('wallet-name').value
    
    if (document.getElementById('policy-address').checked) {
      const wallet = await hwi.registerWalletPath(path, walletName, keychains)
      //const wallet = await hwi.registerWallet("FRZN",keychains)
      //const walletAddress = await hwi.getPolicyAddress(path, wallet.walletPolicy)
      
      const walletAddress = wallet.address
      //const walletAddress = await hwi.getPolicyAddress(path, policy)
      //console.log("MultiSigWallet ", hwi.wallet)

      displayData(walletAddress)

      createQR(walletAddress)

      await getAddressInfo(walletAddress).then(async (infos) => {
        debug && console.log("[infos]: ",infos)
        push(`✅ [SUCCESS] Wallet Policy registered with Address: ${walletAddress}`)
      })
    } else {
      const wallet = await hwi.registerWallet(walletName, keychains)
      //console.log("Wallet ", hwi.wallet)
    }    
    await hwi.closeClient()
  } catch (error) {
    console.log(error)
    push(error)
    await hwi.closeClient()
  }
})

decode.addEventListener("click", () => {
  try {
    let decodedPsbt = {}
    const b64 = document.getElementById('base64').value
    const hex = base64ToHex(b64)
    hexed = hex

    const psbt = bitcoin.Psbt.fromHex(hex,hwi.testnet?TESTNET:MAINNET) //.Psbt.fromHex(hex)

    hwi.importFromB64(b64)
    const txInfo = hwi.getPsbtInfo()
    debug && console.log(txInfo)
    psbtInfo.innerHTML = `${JSON.stringify(txInfo.to)} | ${JSON.stringify(txInfo.signatures)}`
    //console.log(psbt)

    globalPSBT = psbt

    prevTx = psbt.data.globalMap.unsignedTx.tx
    
    decodedPsbt.inputs = {}
    
    for (let i=0;i<psbt.data.inputs.length;i++) {
      decodedPsbt.inputs[i] = {}
      decodedPsbt.inputs[i].bip32 = {}
      if (psbt.data.inputs[i]?.bip32Derivation) {
        for (let j=0;j<psbt.data.inputs[i].bip32Derivation.length;j++) {
          decodedPsbt.inputs[i].bip32[j] = {masterFingerprint:psbt.data.inputs[i].bip32Derivation[j].masterFingerprint.toString('hex'),pubkey:psbt.data.inputs[i].bip32Derivation[j].pubkey.toString('hex'),path:psbt.data.inputs[i].bip32Derivation[j].path}
        }
      }
      decodedPsbt.inputs[i].partialSig = []
      if (psbt.data.inputs[i]?.partialSig) {
        for (let k=0;k<psbt.data.inputs[i].partialSig.length;k++) {
          decodedPsbt.inputs[i].partialSig.push({pubKey:psbt.data.inputs[i].partialSig[k].pubkey.toString('hex'),partialSig:psbt.data.inputs[i].partialSig[k].signature.toString('hex')})
        }
      }
      decodedPsbt.inputs[i].witnessScript = psbt.data.inputs[i].witnessScript?.toString('hex')
      decodedPsbt.inputs[i].witnessUtxo = psbt.data.inputs[i]?.witnessUtxo?.script?.toString('hex')
      decodedPsbt.inputs[i].value = psbt.data.inputs[i]?.witnessUtxo?.value
    }
    decodedPsbt.outputs = {}
    for (let i=0;i<psbt.data.outputs.length;i++) {
      decodedPsbt.outputs[i] = {}
      decodedPsbt.outputs[i].bip32 = {}
      if (psbt.data.outputs[i]?.bip32Derivation) {
        for (let j=0;j<psbt.data.outputs[i].bip32Derivation.length;j++) {
          decodedPsbt.outputs[i].bip32[j] = {masterFingerprint:psbt.data.outputs[i].bip32Derivation[j].masterFingerprint.toString('hex'),pubkey:psbt.data.outputs[i].bip32Derivation[j].pubkey.toString('hex'),path:psbt.data.outputs[i].bip32Derivation[j].path}
        }
      }
      //decodedPsbt.outputs[i] = psbt.data.outputs[i]
    }
    decodedPsbt.options = {}
    
    decodedPsbt.options.maximumFeeRate = psbt.opts.maximumFeeRate
    
    decodedPsbt.options.network = psbt.opts.network.messagePrefix
    
    decodedPsbt.options.bech32 = psbt.opts.network.bech32
    
    decodedPsbt.options.bip32 = psbt.opts.network.bip32
    
    decodedPsbt.options.pubKeyHash = psbt.opts.network.pubKeyHash
    
    decodedPsbt.options.scriptHash = psbt.opts.network.scriptHash
    
    decodedPsbt.options.wif = psbt.opts.network.wif // ???
    
    //document.getElementById("decoded").innerHTML = JSON.stringify(decodedPsbt,null,4)

    psbtFormatted.utxo = {}
    psbtFormatted.utxo.ins = []
    prevTx.ins.forEach(element => {
      psbtFormatted.utxo.ins.push({
        hash: element.hash.toString('hex'),
        index: element.index,
        script: Buffer.from(element.script.buffer).toString('hex'),
        sequence: element.sequence,
        witness: element.witness.toString('hex')
      })
    })
    psbtFormatted.utxo.locktime = prevTx.locktime
    psbtFormatted.utxo.outs = []
    prevTx.outs.forEach(element => {
      psbtFormatted.utxo.outs.push({
        value: element.value,
        script: Buffer.from(element.script.buffer).toString('hex'),
      })
    })
  
    psbtFormatted.utxo.version = prevTx.version

    psbtFormatted.data = decodedPsbt

  } catch (e) {
    push(e)
    console.log(e)
  }
});

signPsbt.addEventListener("click", async () => {
  console.log("signPsbt...")
  //const hwi = new HWI()
  try {
    const b64 = document.getElementById('base64').value
    const path = document.getElementById('path').value
    hwi.importFromB64(b64)
    await hwi.getClient()
    //await hwi.getXpub("m/44'/1'/0'/0/0")
    //await hwi.getAddress("m/44'/1'/0'/0/0")
    const result = await hwi.signPsbt(path)
    //hwi.decodeTX()

    await hwi.closeClient()
    //console.log("HWI Client: ",hwi)
    //console.log("b64: ",hwi.toBase64())
    document.getElementById("exported-b64").innerHTML = hwi.toBase64()

    //const wallet = new Wallet()
    //await hwi.validateSignatures(await wallet.verify(,,))
    /*
    const finalized = await hwi.validateSignatures() //callback()
    console.log("[FINALIZED]: ", finalized.toHex())
    document.getElementById("broadcast").innerHTML = finalized.toHex()
    */
    document.getElementById("signature-result").innerHTML = ""
    const resList = document.createElement('ul')
    result.forEach(el=>{
      const newSig = document.createElement('li')
      //console.log("EL: ",el)
      const txt = document.createTextNode(`${el[0]} : ${el[1].pubkey.toString("hex")} : ${el[1].signature.toString("hex")}`)
      newSig.appendChild(txt)
      resList.appendChild(newSig)
    })
    
    //document.getElementById("exported-b64").innerHTML = hwi.toBase64()
    //document.getElementById("signature-result").innerHTML = `${result[0][0]} : ${result[0][1].pubkey.toString("hex")} : ${result[0][1].signature.toString("hex")}`//JSON.stringify(result)
    
    //document.getElementById("signature-result").innerHTML = `${JSON.stringify(result)}`
    document.getElementById("signature-result").appendChild(resList)

    push(`✅ [SUCCESS] PSBT signed`)
  } catch (error) {
    console.log(error)
    push(error)
    await hwi.closeClient()
  }
})

sign.addEventListener("click", async () => {
  console.log("sign...")
  //const hwi = new HWI()
  try {
    const b64 = document.getElementById('base64').value
    const path = document.getElementById('path').value
    hwi.importFromB64(b64)
    await hwi.getClient()

    const signImported = document.getElementById('sign-imported').checked
    //console.log(signImported)
    const analyzedPsbt = signImported ? await analyzeDecodedPsbt(hwi.psbt) : {}

    // Previous Mined TX
    // 02000000000101f75d0beedf98acda3379d7a42a1243e4c3c2d56bfe1be08b7e12dc1f0c1d1a5701000000000000000002d007000000000000220020e898e861510a655ccdfafef352553c7b8b5e7d85b75bae4f3b0fffa889d6bdfc8b32010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d6938024730440220068d2796c03404e4b3af244d781ba6f06079a2de587e17f83ed1a3cbbcf1fb4c02207992636edd68ea23170ac21deb550adab5b4b5a7ef44afac849ed14a1b9c1b4301210209ed5c211206be21054582fa122681ce85a21418a057c4f6d04bf3084257be9700000000
    // 020000000120f204014c20c733041fc9ae6f525427a809eb73196991fe02fb27ec2c4f13a20100000000fffffffd019031010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d693800000000
    // Serialized Output Script
    // 019031010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d6938

    const radios = document.getElementsByName('utxo');
    const ins = []
    !signImported && globalInfo.prevTxs.map((item,n)=>{
      radios.forEach((radio) => {
        //console.log("[Selecting utxo]: ", parseInt(radio.value), n, i, radio.value)
        if (radio.checked) {        
          if (parseInt(radio.value) === n) {
            ins.push([item[2].tx, item[3], undefined, undefined]) // [tx, outIndex, redeem, sequence] // TODO: if p2sh or locktime change "undefined"
          }
        }
      })
    })

    const paths = []
    for (let i=0;i<ins.length;i++) {
      signImported ? paths.push(...analyzedPsbt.paths) : paths.push(path)
    }

    //const oldTx = hwi.decodeTX("02000000000101f75d0beedf98acda3379d7a42a1243e4c3c2d56bfe1be08b7e12dc1f0c1d1a5701000000000000000002d007000000000000220020e898e861510a655ccdfafef352553c7b8b5e7d85b75bae4f3b0fffa889d6bdfc8b32010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d6938024730440220068d2796c03404e4b3af244d781ba6f06079a2de587e17f83ed1a3cbbcf1fb4c02207992636edd68ea23170ac21deb550adab5b4b5a7ef44afac849ed14a1b9c1b4301210209ed5c211206be21054582fa122681ce85a21418a057c4f6d04bf3084257be9700000000",true,["bech32"])
    //const newTx = hwi.decodeTX("020000000120f204014c20c733041fc9ae6f525427a809eb73196991fe02fb27ec2c4f13a20100000000fffffffd019031010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d693800000000")

    // segwit, additionals
    const segwit = document.getElementById('tx-type').value === "p2sh" || document.getElementById('tx-type').value === "p2wpkh" || document.getElementById('tx-type').value ===  "p2wsh" ? true:false
    const additionals = segwit?["bech32"]:[]

    const newTx = signImported? null : hwi.decodeTX(globalInfo.unsignedTx.serializeUnsigned(),segwit,additionals)
    //const newTx = hwi.decodeTX(globalInfo.unsignedTx.serializeUnsigned())
    
    //console.log("[PATHs]: ", paths)
    //console.log("[INPUTS]: ", newTx.outputScript, ins)
    //console.log("[INS]",...ins)

    let result

    if (signMode) {
      result = await hwi.signP2SHTX(
        //[[oldTx.tx, 1, "", 0]], // inputs // TODO: ???
        signImported ? analyzedPsbt.ins : [...ins],
        signImported ? [...analyzedPsbt.paths] : [...paths], // associated keyChain
        //[path], // change Path
        signImported? analyzedPsbt.newTx.outputScript : newTx.outputScript, //"019031010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d6938", // Output Script Hex // TODO: ???
        segwit, // SegWit
        additionals // Additionals
        //0, // Locktime
        //1, // SigHash type
      )
    } else {
      result = await hwi.createPaymentTX(
        //[[oldTx.tx, 1, "", 0]], // inputs // TODO: ???
        signImported ? analyzedPsbt.ins : [...ins],
        signImported ? [...analyzedPsbt.paths] : [...paths], // associated keyChain
        //[], // change Path
        signImported? analyzedPsbt.newTx.outputScript : newTx.outputScript, //"019031010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d6938", // Output Script Hex // TODO: ???
        segwit, // SegWit
        additionals // Additionals
        //0, // Locktime
        //1, // SigHash type
      )
    }

    //console.log("[RESULT]: ", result)

    await hwi.closeClient()

    document.getElementById("broadcast").innerHTML = result
  } catch (error) {
    push(error)
    console.log(error)
    await hwi.closeClient()
  }
})

signMessage.addEventListener("click", async () => {
  //// https://www.verifybitcoinmessage.com/
  try {
    const path = document.getElementById('path').value
    const message = document.getElementById('message').value
    await hwi.getClient()
    const RandS = document.getElementById('sign-message-mode').checked
    const msg = Buffer.from(message).toString("hex")
    await hwi.signMessage(path, msg, RandS).then(async function(result) {      
      let signature
      if (RandS) {
        signature = Buffer.from(result,'hex').toString('hex') //.toString('base64')
      } else {
        let v = result['v'] + 27 + 4;
        signature = Buffer.from(v.toString(16) + result['r'] + result['s'], 'hex').toString('base64')
      }      
      //console.log("Signature : " + signature);
      document.getElementById('signature').innerHTML = "Signature : " + signature
      
      await hwi.closeClient()
    }).catch(function(ex) {console.log(ex);});
  } catch (err) {
    push(err)
    console.log(err)
    await transport.close().then(()=>{
      console.log(`[LEDGER]: Connection closed`)
    });
  }
})

document.getElementById('finalize').addEventListener("click", async () => {
  console.log("finalizePsbt...")
  try {
    if (document.getElementById("core").checked) {
      const finalized = await makeRpcRequest('finalizepsbt', [document.getElementById('exported-b64').value]);
      //console.log("[FINALIZED]: ", finalized.result)
      if (finalized.result.complete) document.getElementById("broadcast").innerHTML = finalized.result.hex
    } else {
      //await hwi.getClient()
      const finalized = await hwi.validateSignatures() // callback()
      //console.log("[FINALIZED]: ", finalized.toHex())
      document.getElementById("broadcast").innerHTML = finalized.toHex()
      //await hwi.closeClient()
    }
  } catch (error) {
    push(error)
    console.log(error)
    //await hwi.closeClient()
  }
})

document.getElementById('broadcast-tx').addEventListener("click", async () => {
  try {
    if (document.getElementById("core").checked) {
      if (document.getElementById('test-broadcast').checked) {
        console.log("Core test broadcasting...")
        const test = await makeRpcRequest('testmempoolaccept', [[`${document.getElementById('broadcast').value}`]]);
        //console.log("[TEST]: ", test.result)
        document.getElementById("broadcast-result").innerHTML = JSON.stringify(test.result)
      } else {
        console.log("Core broadcasting...")
        const hash = await makeRpcRequest('sendrawtransaction', [document.getElementById('broadcast').value]);
        //console.log("[HASH]: ", hash)
        if (hash.result) document.getElementById("broadcast-result").innerHTML = hash.result
        hash.result && push(`[SUCCESS]: transaction broadcasted with hash ${hash.result}`)
      }
    } else {
      console.log("Mempool broadcasting...")
      const test = hwi.testnet
      const testnet = test?"testnet/":""
      const resApi = await fetch(`https://mempool.space/${testnet}api/tx`,{method: 'POST',body: document.getElementById('broadcast').value})
      const json = await resApi.text()
      console.log("\n[BROADCAST RESULT]: ", json)
      // `https://mempool.space/${testnet}tx/${json}`
      document.getElementById("broadcast-result").innerHTML = json
    }
    
  } catch (error) {
    push(error)
    console.log(error)
    //await hwi.closeClient()
  }
})

async function makeRpcRequest(method, params) {
  //console.log("JSON-RPC")
  const url = document.getElementById('node').value // adjust to your node's RPC URL
  const headers = { 'Content-Type': 'application/json' };
  const data = {
    jsonrpc: '2.0',
    method,
    params,
    id: 1
  };
  try {
    const response = await axios.post(url, data, { headers });
    //console.log("JSON-RESP:",response.data);
    return response.data
  } catch (error) {
    console.error(error);
  }
}

// Bluetooth Low Energy client
function bleClient() {
  const ble = document.getElementById("ble").checked
  if (ble) {
    const networkState = hwi.testnet
    hwi = new HWI(TransportWebBLE)
    hwi.testnet = networkState

  } else {
    const networkState = hwi.testnet
    hwi = new HWI(TransportWebHID)
    hwi.testnet = networkState
  }
  console.log("[BLE]", ble)
}

async function analyzeDecodedPsbt(psbt) {
  console.log(psbt)
  /*
  console.log(psbt.data.globalMap.unknownKeyVals)
  const proprietaryFieldKey = Buffer.from(psbt.data.globalMap.unknownKeyVals[0].key,'hex').toString('hex')
  const proprietaryFieldValue = Buffer.from(psbt.data.globalMap.unknownKeyVals[0].value,'hex').toString('hex')
  console.log(proprietaryFieldKey)
  console.log(proprietaryFieldValue)
  */

  const unsignedTX = Buffer.from(psbt.data.getTransaction(),'hex').toString('hex')
  //console.log(unsignedTX)

  const newTx = hwi.decodeTX(unsignedTX, true, ["bech32"])

  const ins = []
  const prevTxs = []
  const paths = []

  for (txid in psbt.txInputs) {
    const input = psbt.txInputs[txid]   
    const hash = Buffer.from(input.hash.reverse(),'hex').toString('hex')
    const vout = input.index
    //console.log(hash)
    //console.log(vout)
    paths.push(psbt.data.inputs[txid].bip32Derivation[0].path)

    await fetch(`https://blockstream.info/${hwi.testnet?"testnet/":""}api/tx/${hash}/hex`).then(async (prevTx) => {
      await prevTx.text().then(tx => {
        //console.log(tx)
        const oldTx = hwi.decodeTX(tx, true, ["bech32"])
        //console.log(oldTx)
        const outputScript = Buffer.concat([oldTx.tx.outputs[vout].amount, Uint8Array.from([oldTx.tx.outputs[vout].script.length]), oldTx.tx.outputs[vout].script]).toString('hex')
        prevTxs.push([tx, outputScript, oldTx, vout])
        ins.push([oldTx.tx,vout,undefined,undefined])
      })
    })
  }
  // input txid + vout -> tx, outputScript, newTx

  //console.log(ins)
  //console.log(paths)
  //console.log(newTx.outputScript)
  return {ins, paths, newTx}
}

function compressPublicKey(pk) {  
  const sliced = Buffer.from(pk,'hex').slice(1)
  const len = sliced.length
  const x = sliced.slice(0,32)
  const y = sliced.slice(32,sliced.length)
  
  const prefix = BigInt(`0x${y.toString('hex')}`) % 2n === 0n ? "02" : "03"

  return (prefix + pk.slice(2, 66)).toString('hex');
}

function base64ToHex(str) {
  const raw = atob(str);
  let result = '';
  for (let i = 0; i < raw.length; i++) {
    const hex = raw.charCodeAt(i).toString(16);
    result += (hex.length === 2 ? hex : '0' + hex);
  }
  return result.toUpperCase();
}

const displayData = (data) => {
  try {
    //Display your bitcoin address on the screen
    const h2 = document.createElement("h2");
    h2.id = "address"
    h2.textContent = data;
    $main.innerHTML = "<h1>Bitcoin address: </h1>";
    $main.appendChild(h2);
  } catch (error) {
    const $err = document.createElement("code");
    $err.style.color = "#f66";
    $err.textContent = String(e.message || e);
    $main.appendChild($err);
  }  
}

function createQR(data) {
  const div = document.createElement("div");
  div.id = "qrcode"
  $main.appendChild(div)
  // $main
  const qrcode = new QRCode(div, {
    text: data,
    width: 150,
    height: 150,
    colorDark: '#000',
    colorLight: '#fff',
    //correctLevel: QRCode.CorrectLevel.H
  })
}

async function btcInfo() {
  const wallet = new Wallet()
  //block
  block = await wallet.getApi("block", `https://mempool.space/api/blocks/tip/height`)
  //price
  price = (await wallet.getApi("price", `https://mempool.space/api/v1/prices`)).USD
  //console.log(`PRICE: ${price} $ | BLOCK: ${block}`)
  document.getElementById('btc-info').innerHTML = (`PRICE: ${price} $ | BLOCK: ${block}`)
}

function fetchXpubs(keychains) {
  const keys = []
  if (keychains.length > 0) {
    if (keychains.includes(",")) {
      keychains.split(",").map(key=>{
        const derivation = key.split(":")
        const getxpub = derivation[1].split("|")
        //console.log("???: ", derivation,xpub)
        keys.push({fgpr: derivation[0], path: getxpub[0], xpub: getxpub[1]})
      })
    } else {
      const derivation = keychains.split(":")
      const getxpub = derivation[1].split("|")
      //console.log("???: ", derivation,xpub)
      keys.push({fgpr: derivation[0], path: getxpub[0], xpub: getxpub[1]})
    }
  }
  //console.log(keys)
  return keys
}

function fetchPubs(keychains) {
  const keys = []
  if (keychains.length > 0) {
    if (keychains.includes(",")) {
      keychains.split(",").map(key=>{
          const derivation = key.split(":")
          const getpub = derivation[1].split("|")
          //console.log("???: ", derivation,xpub)
          keys.push({fgpr: derivation[0], path: getpub[0], pub: getpub[1]})
      })
    } else {
      const derivation = keychains.split(":")
      const getpub = derivation[1].split("|")
      //console.log("???: ", derivation,getpub)
      keys.push({fgpr: derivation[0], path: getpub[0], pub: getpub[1]})
    }
  }
  //console.log(keys)
  return keys
}

function decodeXpub(xpub) {
  const wallet = new Wallet()
  const decoded = wallet.fromBase58(xpub)
  const step0 = decoded.subarray(0,4)
  const step1 = decoded.subarray(4,5)
  const step2 = decoded.subarray(5,9)
  const step3 = decoded.subarray(9,13)
  const step4 = decoded.subarray(13,45)
  const step5 = decoded.subarray(45,78)

  return {
    depth: Buffer.from(step1).toString('hex'),
    path: Buffer.from(step3).toString('hex'),
    pubkey: Buffer.from(step5).toString('hex')
  }
}

function sortDataBy(data, byKey){
  let sortedData;
  if(byKey == 'id'){
    sortedData = data.sort(function(a,b){
      let x = a.txid.toLowerCase();
      let y = b.txid.toLowerCase();
      if(x>y){return 1;}
      if(x<y){return -1;}
      return 0;
    });
  } else if (byKey == 'value') {
    sortedData = data.sort(function(a,b){
      let x = a.value;
      let y = b.value;
      if(x>y){return 1;}
      if(x<y){return -1;}
      return 0;
    });
  } else if (byKey='txid') {
    sortedData = data.sort(function(a,b){
      return a.txid.localeCompare(b.txid);
    })
  } else {
    sortedData = data.sort(function(a,b){
      return a.value - b.value;
    })
  }
  return sortedData;
}

function push(msg) {
  const div = document.getElementById('push')
  div.innerHTML = msg
  div.style.height = "50px"
  div.style.padding = "10px"
  setTimeout(()=>{
    div.innerHTML = ""
    div.style.height = "auto"
    div.style.padding = ""
  },5000)
}

function addAmount() {
  const radios = document.getElementsByName('utxo');
  selectedAmount = 0
  globalInfo.ids.map((i,n)=>{
    radios.forEach((radio) => {
      if (radio.checked) {        
        if (parseInt(radio.value) === n) {
          // i.txid | i.vout | i.value
          selectedAmount += i.value // satoshi
        }        
      }
    })
  })
  //selectedAmount -= targetFee
  //console.log("[UTXO SELECTED AMOUNT]", selectedAmount)
  //push(`[UTXO SELECTED AMOUNT]: ${selectedAmount/satoshi} ₿`)
}

function estimateFees(fee, size, wit, totInputs=1, segwit=true) {
  // ( witnessLen + ((signatureLen + pubkeyLen) * N) + flagLen ) / 4 + txSizeLen
  const flagLen = 2
  const witLen = segwit ? wit / 4 : 0 //(Buffer.from(wit,'hex').length * totInputs) / 4 : 0
  const scriptSigLen = segwit ? 0 : 22
  //const mulLen = 1 * totInputs
  const pubLen = 34
  //const sigLen = segwit ? ((73 + pubLen) * mul) / 4 : ((73 + pubLen) * mul)
  const sigLen = segwit ? (73 / 4) * totInputs : ((73 + pubLen) * totInputs)
  let est = (parseInt(fee) / parseInt(flagLen + size + sigLen + witLen)).toFixed(2)
  //document.getElementById('est-fees').value = est
  //estFees = est
  //console.log(`[Fee]: ${fee}, [Bytes]:${size + sigLen + witLen}, [*]: ${mul}`)
  console.log("[sats/vbyte]: ", est)
  return est
}

async function getAddressInfo(address, display=true) {
  //const path = document.getElementById('path').value
  //const fgpr = await hwi.getFingerprint()
  //const xpub = await hwi.getXpub(path)
  
  const balanceView = document.getElementById('balance')  
  const panel = document.getElementById('utxos')
  const txType = document.getElementById('tx-type').value
  let addrType = ""

  if (address.startsWith('1') || address.startsWith('m')) {
    addrType = "p2pkh"
  }
  if (address.startsWith('3') || address.startsWith('2')) {
    addrType = "p2sh"
  }
  if (address.startsWith('bc') && address.length === 42 || address.startsWith('tb') && address.length === 42) {
    addrType = "p2wpkh"
  }
  if (address.startsWith('bc') && address.length > 42 || address.startsWith('tb') && address.length > 42) {
    addrType = "p2wsh"
  }

  // RESET UTXO LIST
  if (display) {
    panel.innerHTML = ""
  }
  if (!document.getElementById('coinjoin').checked) {
    coinjoin = []
  }
  const addresses = address.split(",")
  //console.log(">>> ",addresses)

  // PARAMETERS
  const test = hwi.testnet
  const testnet = test?"testnet/":""
  //const from = address
  //let balance = 0
  let ids = []
  let prevTxs = []
  const wallet = new Wallet()

  //addresses.map(async(addr)=> {
    const from = address
  
    // ONLINE
    try {
      //balance
      const status = await wallet.getApi("status",`https://mempool.space/${testnet}api/address/${from}`)
      //txs
      const txs = await wallet.getApi("utxo", `https://mempool.space/${testnet}api/address/${from}/txs`)
      //utxo
      const utxo = await wallet.getApi("txs", `https://mempool.space/${testnet}api/address/${from}/utxo`)
      //block
      //const block = await wallet.getApi("block", `https://mempool.space/${testnet}api/blocks/tip/height`)
      //price
      //const price = await wallet.getApi("price", `https://mempool.space/api/v1/prices`)

      //const broadcast = https://mempool.space/testnet/api/tx //POST
      
      //console.log("[STATUS]: ", status)
      //console.log("[UTXO]: ", utxo)
      //console.log("[TXS]: ", txs)
      //console.log("[vout]: ", txs[0].vout)
      /*
      console.log("[BLOCK]: ", block)
      console.log("[PRICE]: ", price)
      */
      balance += status.chain_stats.funded_txo_sum - status.chain_stats.spent_txo_sum
      
      utxo.map(id=>{
        ids.push({address:from,type:addrType,txid:id.txid,vout:id.vout,value:id.value})
        //coinjoin.push({txid:id.txid,vout:id.vout,value:id.value})
      })
      //ids = sortDataBy(ids,"txid")

      //ids = sortDataBy(ids,"id")
      //ids = sortDataBy(ids,"value")
      //ids = sortDataBy(ids)
      //ids.sort((a,b)=> a.value < b.value)
      // ids.sort((a,b)=> {
      //   console.log("??? ",a,b)
      //   return a.txid < b.txid
      // })
    } catch (error) {
      console.log("[API] error: unable to get utxos")
      push(`⚠️ [API] error: unable to get utxos`)
      //console.log(error)
    }
  //})  

  ids = sortDataBy(ids,"txid")
  coinjoin.push(...ids)

  //console.log("[BALANCE]: ", balance)
  balanceView.innerHTML = `₿ ${balance/satoshi} | (${balance}) sats | $ ${((balance/satoshi)*price).toFixed(2)}`

  // Return if no Balance
  if (balance === 0) {
    console.log("[NO BALANCE AVAILABLE]")
    //return
  }
  // Display UTXOs
  display && coinjoin.length > 0 && coinjoin.map((item,i)=>{
    const newUtxo = document.createElement('li');    

    const radio = document.createElement('input')
    radio.type = 'checkbox';
    radio.name = 'utxo';
    radio.value = `${i}`; // Set the value attribute
    newUtxo.appendChild(radio)

    //const x = document.createTextNode(`#${i} : ${JSON.stringify(item)} [${item.value/satoshi}] $ ${((item.value/satoshi)* price).toFixed(2)}`)
    const x = document.createTextNode(` #${i} : ₿ ${item.value/satoshi} | ${item.address} $ ${((item.value/satoshi)* price).toFixed(2)}`)
    newUtxo.appendChild(x);

    panel.appendChild(newUtxo);
    //console.log(i,item)
  })

  for (let i=0;i<coinjoin.length;i++) {
    await fetch(`https://mempool.space/${testnet}api/tx/${coinjoin[i].txid}/hex`).then(async(prevTx)=>{
      await prevTx.text().then(tx=>{
        //console.log("[PREVTX]: ", tx)
        //const oldTx = hwi.decodeTX(tx, true, ["bech32"]) // TODO: ???
        //const oldTx = hwi.decodeTX(tx, false, []) // TODO: ???
        const oldTx = hwi.decodeTX(tx, txType === "p2sh" || txType === "p2wpkh" || txType === "p2wsh" ? true :false, txType === "p2wpkh" || txType === "p2wsh" ?["bech32"]:[]) // TODO: ???
        //console.log("[OLDTX]: ", oldTx)
        const outputScript = Buffer.concat([
          //Uint8Array.from([0x01]), // ???
          oldTx.tx.outputs[coinjoin[i].vout].amount,
          Uint8Array.from([oldTx.tx.outputs[coinjoin[i].vout].script.length]),
          oldTx.tx.outputs[coinjoin[i].vout].script
        ]).toString('hex')    
        //console.log("[>>>] ", outputScript)
        prevTxs.push([tx, outputScript, oldTx, coinjoin[i].vout])
        //return [tx,outputScript,oldTx]
      })
    })
  }
  //console.log("[COINJOIN]: ", coinjoin)
  globalInfo = {address,prevTxs, ids:coinjoin, balance}
  return {prevTxs, ids:coinjoin, balance}
}

async function createUnsignedTx(address, pubkey, ids, values, balance, type="p2wpkh") {
  const network = "testnet"
  const version = 2
  const segwit = true
  //const type = "p2wpkh" // TODO: ???
  const wallet = new Wallet()
  // FROM SPENDER
  const pkh = Buffer.from(wallet.hash160(Buffer.from(pubkey,'hex'))).toString('hex')
  //console.log("[from]: ", from)
  //console.log("[pubkey/redeem|witness]: ", Buffer.from(pubkey,'hex').toString('hex'))
  //console.log("[pkh/sh ripemd160] ", Buffer.from(wallet.hash160(Buffer.from(pubkey,'hex'))).toString('hex'))
  //console.log("[pkh/sh sha256] ", Buffer.from(wallet.sha256(Buffer.from(pubkey,'hex'))).toString('hex'))
  // CREATE TX
  const tx = new TX(network,version,segwit,type)
  tx.debugger = document.getElementById('debug-mode').checked
  const fees = targetFee //document.getElementById('fees').value
  tx.setFee(parseInt(fees))
  let _pubkey = Buffer.from(pubkey,'hex').toString('hex')
  // CREATE TX INPUTS  
  const radios = document.getElementsByName('utxo');
  let toSpend = 0
  //<input type="radio" name="utxo" id="0">  
  ids.map((i,n)=>{
    radios.forEach((radio) => {
      //console.log("[Selecting utxo]: ", parseInt(radio.value), n, i, radio.value)
      if (radio.checked) {
        if (parseInt(radio.value) === n) {
          //console.log("[*SELECTED UTXO*]: ", radio.value)
          toSpend += i.value 
          tx.createInput(i.txid, _pubkey, i.type, i.vout)
        }        
      }
    })
    //tx.createInput(i.txid, _pubkey, type, i.vout)
  })
  // CREATE TX OUTPUTS
  const addresses = address.split(",")
  const amounts = values.split(",")
  
  //amounts[0] = amounts[0] - parseInt(fees)
  //console.log("TX-ADRESSES+AMOUNT", addresses, amounts)

  let sum = 0
  addresses.map((addr,i) => {
    const amount = parseInt(parseFloat(amounts[i]) * satoshi)
    sum += parseInt(amounts[i])
    //if ((sum - fees) >= balance) { return }
    amounts[i] > 0 && tx.createOutput(amounts[i], addr)
    //console.log("[*OUT*]: ", sum, amounts[i], addr)
  })

  let changeAddress = document.getElementById("addr-from").value
  let rest = toSpend - sum - parseInt(fees)//(sum - parseInt(fees))
  //console.log("[toSpend]: ",toSpend)
  //console.log("[FEES]:",rest, "[REST to CHANGE:]", rest - parseInt(fees))

  if (rest < 0) {
    //console.log("[ERROR]: Fees are wrong!")
    push(`⚠️ [ERROR]: Fees are wrong! ${rest}`)
    throw "[ERROR]: Fees are wrong!"
    //return // ATTENTION!!!!! This cause a loop
  }

  if (rest > 0) { //(sum - parseInt(fees)) <= balance
    let changeAmount = rest - parseInt(fees) //balance - (sum - parseInt(fees))
    if (changeAmount < 0) {
      push(`⛔️ [ERROR]: Change amount negative: try to reduce fees ${changeAmount}`)
      throw "⛔️ [ERROR]: Change amount negative: try to reduce fees!"
    }
    console.log("[CHANGE]: ", rest / 10 ** 8, changeAddress)
    tx.createOutput(rest, changeAddress)
  }

  //const size = globalInfo.unsignedTx.serializeUnsigned().length
  //estimateFees(fees,size,globalInfo.pubkey)

  //tx.createOutput((balance - tx.fee).toString(), address)
  // SERIALIZE UNSIGNED TX
  const unsignedTx = tx//.serializeUnsigned()
  globalInfo.pubkey = pubkey
  globalInfo.unsignedTx = unsignedTx
  return unsignedTx
}

async function createPsbt(pubkey, ids, prevTxs, unsignedTx, globalXpubs, bip32Derivations,type="p2wpkh") {
  const path = document.getElementById('path').value
  //const fgpr = await hwi.getFingerprint()
  //const xpub = await hwi.getXpub(path)
  const wallet = new Wallet()
  // TODO: Tx type is needed to set the script hash
  // FROM SPENDER
  const pkh = Buffer.from(wallet.hash160(Buffer.from(pubkey,'hex'))).toString('hex') // P2WPKH
  //const pkh = Buffer.from(wallet.sha256(Buffer.from(pubkey,'hex'))).toString('hex') // P2WSH
  //console.log("[pubkey/redeem|witness]: ", Buffer.from(pubkey,'hex').toString('hex'))
  //console.log("[pkh/sh ripemd160] ", Buffer.from(wallet.hash160(Buffer.from(pubkey,'hex'))).toString('hex'))
  //console.log("[pkh/sh sha256] ", Buffer.from(wallet.sha256(Buffer.from(pubkey,'hex'))).toString('hex'))
  
  let keyChains = [
    ...globalXpubs
    //{xpub:xpub,fgpr:fgpr,path:path.replaceAll("'","h")}
  ]

  let bip32Chain = [
    ...bip32Derivations
    //{pub:pubkey,fgpr:fgpr,path:path.replaceAll("'","h")}
  ]

  let partialSig = [
    //{pub:"",sig:""}
  ]

  //const scriptCode = `1976a914${pkh}88ac`
  const scriptCode = "" // P2WPKH | P2WSH 1976a914  88ac
  const redeemScript = type === "p2sh" ? `0014${pkh}` : "" // P2WPKH | P2WSH 0014
  const witnessScript = type === "p2sh" || type === "p2pkh" ? "" : pubkey //"" //`1976a914${pkh}88ac`

  // CREATE PSBT
  const psbtVersion = 0
  const unsignedTxVersion = 2
  const psbt = new PSBT(psbtVersion)
  psbt.testnet = hwi.testnet
  psbt.debugger = document.getElementById('debug-mode').checked
  const tx = unsignedTx

  const bip32Ins = bip32Derivations.length > 0 && document.getElementById('coinjoin').checked? bip32Derivations.split(';') : []
  const witnesses = pubkey.length > 0 && document.getElementById('coinjoin').checked? pubkey.split(',') : []
  //console.log("bip32Ins",bip32Ins)
  //console.log("witnesses",witnesses)
  let nInput = 0
  let nMul = 0

  let toSpend = 0
  let lenWitnesses = 0

  // ADD INPUTS to PSBT
  const radios = document.getElementsByName('utxo');
  ids.map((i,n)=>{
    radios.forEach((radio) => {
      if (radio.checked) {
        if (parseInt(radio.value) === n) {
          toSpend += i.value
          //console.log("[VALUE]: ",i.value)
          const oldTx = hwi.decodeTX(prevTxs[n][0], i.type === "p2sh" || i.type === "p2wpkh" || i.type === "p2wsh" ? true:false, i.type === "p2wpkh" || i.type === "p2wsh" ? ["bech32"]:[])
          const outputScript = Buffer.concat([
            oldTx.tx.outputs[i.vout].amount,
            Uint8Array.from([oldTx.tx.outputs[i.vout].script.length]),
            oldTx.tx.outputs[i.vout].script
          ]).toString('hex')
          //console.log("[OUTPUT SCRIPT>>>]: ", outputScript)
          //console.log("[input-type]",i.type)
          //console.log("[ID]: ",n,i,outputScript)
          //console.log("[PREVTX]",prevTxs[n][0].length/2,Buffer.from(prevTxs[n][0],'hex').toString('hex'))

          if (!document.getElementById('coinjoin').checked) {
            // Previous Entire Transaction must be included eventually with previous unspent transaction Output Script
            if (i.type === "p2pkh") {psbt.addInput(false,Buffer.from(prevTxs[n][0],'hex').toString('hex'),i.txid, i.vout, bip32Chain, partialSig, redeemScript, witnessScript)}
            if (i.type === "p2sh") {psbt.addInput(true,outputScript, i.txid, i.vout, bip32Chain, partialSig, redeemScript, witnessScript,Buffer.from(prevTxs[n][0],'hex').toString('hex')); lenWitnesses += redeemScript.length + witnessScript.length}
            if (i.type === "p2wpkh" || i.type === "p2wsh") {psbt.addInput(true,outputScript, i.txid, i.vout, bip32Chain, partialSig, redeemScript, witnessScript); lenWitnesses += witnessScript.length}
          }
          if (document.getElementById('coinjoin').checked) {
            //console.log(">>>",n,bip32Ins[nInput],witnesses[nInput])
            const bip32Chainx = bip32Ins.length > 0 ? [...fetchPubs(bip32Ins[nInput])] : []
            const redeem = `0014${Buffer.from(wallet.hash160(Buffer.from(witnesses[nInput],'hex'))).toString('hex')}`
            nMul += bip32Ins.length
            //console.log("bip32Chainx",bip32Chainx)
            if (i.type === "p2pkh") {psbt.addInput(false,Buffer.from(prevTxs[n][0],'hex').toString('hex'),i.txid, i.vout, bip32Chainx, partialSig, redeemScript, witnesses[nInput])}
            if (i.type === "p2sh") {psbt.addInput(true,outputScript, i.txid, i.vout, bip32Chainx, partialSig, redeem, "", Buffer.from(prevTxs[n][0],'hex').toString('hex')); lenWitnesses += redeemScript.length + witnesses[nInput].length}
            if (i.type === "p2wpkh" || i.type === "p2wsh") {psbt.addInput(true,outputScript, i.txid, i.vout, bip32Chainx, partialSig, redeemScript, witnesses[nInput]); lenWitnesses += witnesses[nInput].length}
          }
          nInput++
        }        
      }
    })
  })

  // ADD OUTPUTS to PSBT
  const addrTo = document.getElementById('addr-to').value
  const amount = document.getElementById('amount').value
  
  const addresses = addrTo.split(",")
  const amounts = amount.split(",")
  //console.log("PSBT-ADRESSES+AMOUNT", addresses, amounts)

  let totSpend = 0
  
  addresses.map((addr,i)=>{
    const amount = parseInt(parseFloat(amounts[i]) * satoshi)
    const len = addr.length
    const isBase = len <= 35 //
    const outScript = isBase ? (wallet.fromBase58(addr)).slice(2) : (wallet.fromBech32(addr)).slice(2)
    //const outScript = type === "p2sh" || type === "p2pkh" ? (wallet.fromBase58(addr)).slice(2) : (wallet.fromBech32(addr)).slice(2)
    //console.log("[*******] ", i, amounts[i] , Buffer.from(outScript.slice(2)).toString('hex'))
    psbt.addOutput(amounts[i].toString(), Buffer.from(outScript,'hex'), [])
    //psbt.addOutput("0", "", [])
    totSpend += parseInt(amounts[i])
  })
  let rest = parseInt(toSpend) - parseInt(totSpend) - parseInt(targetFee)
  //console.log("PSBT-REST", rest)
  if (rest > 0) {
    psbt.addOutput(rest.toString(), "", [])
  }
  //psbt.addOutput()
  //psbt.addOutput((balance - tx.fee).toString(), Buffer.from(pubkey,'hex'), []) // bip32Chain
  //psbt.addOutput((balance - tx.fee).toString(), Buffer.from(pkh,'hex'), [])

  // ADD GLOBAL MAP to PSBT
  psbt.addGlobalMap(unsignedTx.serializeUnsigned(), unsignedTxVersion, keyChains) // keyChains
  
  const serializedPsbt = psbt.serialize()

  document.getElementById('base64').value = psbt.base64

  //psbt.debug()
  document.getElementById('fees').value = targetFee
  const fees = targetFee //document.getElementById('fees').value
  const size = globalInfo.unsignedTx.serializeUnsigned().length
  const segwit = type === 'p2wpkh' || type === 'p2wsh' || type === 'p2sh' ? true : false
  const target = estimateFees(fees, size, lenWitnesses /*globalInfo.pubkey*/, document.getElementById('coinjoin').checked ? nInput : bip32Chain.length, segwit) // TODO: 1?
  return target
  //console.log("[PSBT-BASE64]: ", psbt.toBase64()) // Buffer.from(serializedPsbt).toString('base64')
  //console.log("[CHECK]: ",psbt.testnet, balance.value, bip32Chain,keyChains)
}

async function createPaymentTx(unsignedTx, prevTxs) {
  // TODO: allow signing for different paths
  const path = document.getElementById('path').value
  const newTx = hwi.decodeTX(unsignedTx)
  //console.log("[prevTxs]: ",prevTxs)
  // [inTx,outIndex,redeem,sequence] [oldTx,1,"",0]
  const ins = []
  prevTxs.map(item=>{
    ins.push([item[2].tx, item[3], undefined, undefined]) // [tx, outIndex, redeem, sequence] // TODO: if p2sh or locktime change "undefined"
    //ins.push([item[2].tx, item[3]])
    //console.log("[ITEM]: ", [item[2], item[3], "", 0])
  })
  console.log("[INPUTS]: ", newTx.outputScript, ins)
  console.log("[INS]",...ins)

  const paths = []
  for (let i=0;i<ins.length;i++) {
    paths.push(path)
  }
  console.log("[PATHs]: ", paths)

  await hwi.createPaymentTX(
    [...ins],
    //[[oldTx,1,"",0]], // inputs
    //[prevTxs.map(item=>{return [item[2], item[3], "", 0]})],
    [...paths], // associated keyChain // TODO: path * number of inputs
    //["m/84'/0'/0'/1/0","change"], // change Path
    newTx.outputScript, //"", // Output Script Hex
    true, // SegWit
    ["bech32"] // Additionals // TODO: make a switch from path to determine additionals
    //0, // Locktime // TODO: allow to set a Locktime
    //1, // SigHash type
  )
  .then(result=>{
    console.log("[RESULT]: ", result)
    document.getElementById("broadcast").innerHTML = result
  })  
}

async function signP2SHTx(unsignedTx, prevTxs) {
  const path = document.getElementById('path').value
  const newTx = hwi.decodeTX(unsignedTx)
  //console.log("[prevTxs]: ",prevTxs)
  // [inTx,outIndex,redeem,sequence] [oldTx,1,"",0]
  const ins = []
  prevTxs.map(item=>{
    ins.push([item[2].tx, item[3], ""])
    //ins.push([item[2].tx, item[3]])
    //console.log("[ITEM]: ", [item[2], item[3], "", 0])
  })
  console.log("[INPUTS]: ", newTx.outputScript, ins)
  console.log("[INS]",...ins)
  const paths = []
  for (let i=0;i<ins.length;i++) {
    paths.push(path)
  }
  console.log("[PATHs]: ", paths)
  await hwi.signP2SHTX(
    [...ins],
    //[[oldTx,1,"",0]], // inputs
    //[prevTxs.map(item=>{return [item[2], item[3], "", 0]})],
    [...paths], // associated keyChain
    //["m/84'/0'/0'/1/0","change"], // change Path
    newTx.outputScript, //"", // Output Script Hex
    true, // SegWit
    ["bech32"] // Additionals
    //0, // Locktime
    //1, // SigHash type
  )
  .then(result=>{
    console.log("[RESULT]: ", result)
    document.getElementById("broadcast").innerHTML = result
  })  
}
